import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import { ApiContext } from "../contexts/ApiContext";
import { generateTitle } from "../utils/utils";
import Footer from "./Footer";
import Header from "./Header";
import LoadingInitial from "./LoadingInitial";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`;

const Body = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: ${isMobile ? "5px" : "110px"};
  
  @media (max-width: 1199px) {
    margin-top: 110px;
  }
`;

const Layout = ({ children, location, title, meta_description }) => {
  // const [title, setTitle] = useState();
  const { isLoading } = useContext(ApiContext);
  const [loading, setLoading] = useState(isLoading);

  useEffect(() => {
    // setTitle(generateTitle());
    window.scrollTo(0, 0);
    setLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    // Check if the element with the CSS class is present
    const targetElement = document.querySelector('.alertBanner');

    if (targetElement) {
      // Apply additional CSS styles to another element if the target element is present
      const elementToStyle = document.querySelector('.layoutBody');

      if (elementToStyle) {
        elementToStyle.style.marginTop = '120px';
      }
    }
  }, []);

  return (
    <>
      {loading ? (
        <LoadingInitial />
      ) : (
        <>
          <Helmet>
            <title>{title ? title : generateTitle()}</title>
            <meta name="description" content={meta_description} />
          </Helmet>
          <Container>
            <Header location={location} />
            <Body className="layoutBody">{children}</Body>
            <Footer />
          </Container>
        </>
      )}
    </>
  );
};

export default Layout;
